import { useState } from "react";

export default function AssignLocation() {
  const [employeeId, setEmployeeId] = useState("");
  const [name, setName] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [message, setMessage] = useState("");

  const BASE_URL = "https://api.timelyhealth.in/api/employees";

  const handleAssign = async () => {
    try {
      const res = await fetch(`${BASE_URL}/assign-location/${employeeId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, latitude, longitude }),
      });

      const data = await res.json();
      setMessage(data.message);
    } catch (err) {
      setMessage("Error assigning location");
    }
  };

  return (
    <div className="p-6 max-w-md mx-auto bg-[#0a0a0a] rounded-xl shadow-md">
      <h2 className="text-xl font-semibold mb-4">Assign Location to Employee</h2>

      <input
        type="text"
        placeholder="Employee ID"
        value={employeeId}
        onChange={(e) => setEmployeeId(e.target.value)}
        className="border p-2 w-full mb-2"
      />
      <input
        type="text"
        placeholder="Location Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        className="border p-2 w-full mb-2"
      />
      <input
        type="number"
        placeholder="Latitude"
        value={latitude}
        onChange={(e) => setLatitude(e.target.value)}
        className="border p-2 w-full mb-2"
      />
      <input
        type="number"
        placeholder="Longitude"
        value={longitude}
        onChange={(e) => setLongitude(e.target.value)}
        className="border p-2 w-full mb-2"
      />

      <button
        onClick={handleAssign}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 w-full"
      >
        Assign Location
      </button>

      {message && <p className="mt-4 text-center text-gray-300">{message}</p>}
    </div>
  );
}
